import logo from './logo.svg';
import './App.css';
import AppRouter from "./AppRouter";
import {UserProvider} from "./Context/UserContext";
import {ModalProvider} from "./Context/ModalContext";
import Modal from "./Components/Modal";
import {ProjectProvider} from "./Context/ProjectContextV2";

function App() {
  return (
    <div className="App">
        <UserProvider>
            <ProjectProvider>
                <ModalProvider>
                    <Modal />
                    <AppRouter />
                </ModalProvider>
            </ProjectProvider>
        </UserProvider>

    </div>
  );
}

export default App;
